export default __webpack_public_path__ + "068680343cf921d48c683d08ba247c41.png";